<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'common.date.start' | translate }}</label>
    <input type="date" appInput formControlName="start">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.date.end' | translate }}</label>
    <input type="date" appInput formControlName="end">
  </app-input-group>
</form>
